<template>
    <jet-dialog-modal :show="true" @close="close">
        <template #title>
            <div
                class="searching-background-color py-2 rounded-md rounded-b-none text-white font-bold text-lg pl-6 -mx-6 -my-4 mb-6">
                View as 100{{ convert100GramType == 'Gram' ? 'g' : 'ml' }}
            </div>
        </template>

        <template #content>


            <div class="mb-4">
                <div class="grid md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-3">
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            calories
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_calories"
                                name="nutrition_facts_calories" :value="convertToGrams(form.nutrition_facts_calories)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">cals</p>
                        </div>

                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            cal/fat
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_calfat"
                                name="nutrition_facts_calfat" :value="convertToGrams(form.nutrition_facts_calfat)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-gray-400">cals</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            total fat
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_totalfat"
                                name="nutrition_facts_totalfat" :value="convertToGrams(form.nutrition_facts_totalfat)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            sat fat
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_satfat"
                                name="nutrition_facts_satfat" :value="convertToGrams(form.nutrition_facts_satfat)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            trans fat
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_transfat"
                                name="nutrition_facts_transfat" :value="convertToGrams(form.nutrition_facts_transfat)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Polyunsat Fat
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_polysatfat"
                                name="nutrition_facts_polysatfat" :value="convertToGrams(form.nutrition_facts_polysatfat)"
                                class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Monounsat Fat
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_monosatfat"
                                name="nutrition_facts_monosatfat" :value="convertToGrams(form.nutrition_facts_monosatfat)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            cholesterol
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_cholesterol"
                                name="nutrition_facts_cholesterol" :value="convertToGrams(form.nutrition_facts_cholesterol)"
                                class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class=" text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            sodium
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_sodium"
                                name="nutrition_facts_sodium" :value="convertToGrams(form.nutrition_facts_sodium)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            potassium
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_potassium"
                                name="nutrition_facts_potassium" :value="convertToGrams(form.nutrition_facts_potassium)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            carbs
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_carbs"
                                name="nutrition_facts_carbs" :value="convertToGrams(form.nutrition_facts_carbs)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            fiber
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_fiber"
                                name="nutrition_facts_fiber" :value="convertToGrams(form.nutrition_facts_fiber)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Total Sugar
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_sugar"
                                name="nutrition_facts_sugar" :value="convertToGrams(form.nutrition_facts_sugar)"
                                class="hadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>

                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Added Sugar
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_added_sugars"
                                name="nutrition_facts_added_sugars" :value="convertToGrams(form.nutrition_facts_added_sugars)"
                                class="hadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            protein
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_protein"
                                name="nutrition_facts_protein" :value="convertToGrams(form.nutrition_facts_protein)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            vitamin a
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_vitamina"
                                name="nutrition_facts_vitamina" :value="form.nutrition_facts_vitamina"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mcg RAE</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            vitamin b6
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_vitaminb6"
                                name="nutrition_facts_vitaminb6" :value="form.nutrition_facts_vitaminb6"
                                class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class=" text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            vitamin b12
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_vitaminb12"
                                name="nutrition_facts_vitaminb12" :value="form.nutrition_facts_vitaminb12"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mcg</p>
                        </div>

                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            vitamin c
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_vitaminc"
                                name="nutrition_facts_vitaminc" :value="form.nutrition_facts_vitaminc"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            vitamin d
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_vitamind"
                                name="nutrition_facts_vitamind" :value="form.nutrition_facts_vitamind"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mcg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            vitamin e
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_vitamine"
                                name="nutrition_facts_vitamine" :value="form.nutrition_facts_vitamine"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            calcium
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_calcium"
                                name="nutrition_facts_calcium" :value="form.nutrition_facts_calcium"
                                class=" shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            iron
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_iron"
                                name="nutrition_facts_iron" :value="convertToGrams(form.nutrition_facts_iron)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            magnesium
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_magnesium"
                                name="nutrition_facts_magnesium" :value="convertToGrams(form.nutrition_facts_magnesium)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Cobalamin
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_coblamin"
                                name="nutrition_facts_coblamin" :value="convertToGrams(form.nutrition_facts_coblamin)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Thiamine
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_thiamin"
                                name="nutrition_facts_thiamin" :value="convertToGrams(form.nutrition_facts_thiamin)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class=" text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Riboflavin
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_riboflavin"
                                name="nutrition_facts_riboflavin" :value="convertToGrams(form.nutrition_facts_riboflavin)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            Niacin
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_niacin"
                                name="nutrition_facts_niacin" :value="convertToGrams(form.nutrition_facts_niacin)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            zinc
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_zinc"
                                name="nutrition_facts_zinc" :value="convertToGrams(form.nutrition_facts_zinc)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">mg</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600 ">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            water
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" step='0.01' id="nutrition_facts_water"
                                name="nutrition_facts_water" :value="convertToGrams(form.nutrition_facts_water)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-gray-400">g</p>
                        </div>
                    </div>
                    <div class="text-left text-sm font-bold text-gray-600">
                        <label scope="col" class="pb-1 text-left text-sm font-bold text-gray-600 capitalize flex w-full">
                            ash
                        </label>
                        <div class="flex items-center">
                            <input disabled type="number" min="0" id="nutrition_facts_ash" name="nutrition_facts_ash"
                                :value="convertToGrams(form.nutrition_facts_ash)"
                                class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                            <p class="text-sm text-gray-400">g</p>
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <template #footer>
            <div class="flex justify-end items-center">
                <button @click="close()"
                    class="inline-flex items-center px-4 border border-gray-300 rounded-md uppercase tracking-widest shadow-sm focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200 active:text-gray-800 active:bg-gray-50 disabled:opacity-25 transition bg-gray-500 text-white justify-center font-bold  py-2 text-base mr-2">Close</button>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import JetDialogModal from '@/Jetstream/DialogModal';

export default {
    props: ['form', 'mass_measurements', 'convert100Gram', 'convert100GramType', 'volume_measurements'],
    components: {
        DefaultLayout,
        Welcome,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
        JetDialogModal
    },

    data() {
        return {
        }
    },
    methods: {

        close() {
            this.$emit('closePopUp', false);
            // convert100Gram = false
        },

        convertToGrams(value) {
            let scale = 1;
            if (this.convert100GramType == 'Gram') {
                let nutrition_mass_measurement = this.form.nutrition_mass_measurement;
                this.mass_measurements.forEach(mass => {
                    if (nutrition_mass_measurement == mass.id) {
                        nutrition_mass_measurement = mass.name;
                    }
                });
                let converted = this.$conversions.weight(this.form.nutrition_facts_weight, nutrition_mass_measurement, this.convert100GramType);
                scale = 100 / converted;
            } else {
                let nutrition_vol_measurement = this.form.nutrition_vol_measurement;
                this.volume_measurements.forEach(mass => {
                    if (nutrition_vol_measurement == mass.id) {
                        nutrition_vol_measurement = mass.name;
                    }
                });
                let converted = this.$conversions.volume(this.form.nutrition_facts_volume, nutrition_vol_measurement, this.convert100GramType);
                scale = 100 / converted;

                console.log('convertToGrams', scale, this.form.nutrition_facts_volume, nutrition_vol_measurement, value * scale);
            }




            //console.log('convertToGrams', scale, this.form.nutrition_facts_weight, nutrition_mass_measurement, value * scale);
            // return this.$helpers.nearestValue(value * scale);
            return this.$helpers.roundToThousandths(value * scale);


        }

    },
};
</script>
